'use client';

import { useOrganization } from '@clerk/nextjs';

/**
 * Hook to check if the current user has admin role in their organization.
 * Returns isAdmin: true only when org data is loaded and role is org:admin.
 */
export function useIsAdmin() {
  const { membership, isLoaded } = useOrganization();

  if (!isLoaded) {
    return { isAdmin: false, isLoading: true };
  }

  return {
    isAdmin: membership?.role === 'org:admin',
    isLoading: false,
  };
}
